export default __webpack_public_path__ + "static/media/Inventory-black-icon.580716e4.svg";